import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import { LAYOUTS } from 'bundles/ai-coach-platform/components/patterns/popover/constants';

export const useLayout = () => {
  const isMobile = useMediaQuery(breakpoints.down('xs'));
  return isMobile ? LAYOUTS.DRAWER : LAYOUTS.DROPDOWN;
};
